<template>
  <b-modal class="modal-lg" id="editRuleModalNew" ref="edit-rule-modal-new" :title="modal.modalData.title" :header-bg-variant="'secondary'" hide-backdrop okVariant="secondary" @show="setDefaults()" @hide="hideModal()">
    <template slot="modal-header" slot-scope="{ close }">
      <h5 class="modal-title text-light"><fontAwesomeIcon :icon="['fa', 'pen']" size="1x" class="mr-2"/> {{ modal.modalData.title }}</h5>
      <button aria-label="Close" class="close" data-dismiss="modal" type="button" @click="close()"><span aria-hidden="true" class="text-light">X</span></button>
    </template>
    <template slot="default">
      <template v-if="!hasConflict && !isLoading">
        <div class="col-12 text-left px-2 mt-2 mb-2" style="border-bottom: 1px solid #ccc;">{{ t('ruleValuesHeader') }}</div>
        <div class="col-12 row align-items-baseline">
          <p class="col-sm-12">{{ t('id','id') }}: {{ modal.ruleData.id }}</p>
        </div>
        <div class="col-sm-12 col-md-12 col-lg-12 px-2 mb-3 pb-3">
          <div class="col-12 text-left px-0 mt-2 mb-2">{{ t('exceptionDescriptionLabel', 'exceptionDescriptionLabel') }}</div>
          <input id="description" v-model="editRuleData.description" class="form-control" :placeholder="t('descriptionPlaceholder', 'descriptionPlaceholder')" type="text">
        </div>
        <template>
          <div class="row mx-0">
            <p class="col-6">{{ t('ruleEnabledStatus', 'ruleEnabledStatus') }}: </p>
            <select v-model="editRuleData['enabled']"  class="form-control custom-select text-capitalize col-6">
              <option :value="1">{{ t('ruleEnabledOption','ruleEnabledOption') }}</option>
              <option :value="0">{{ t('ruleDisabledOption','ruleDisabledOption') }}</option>
            </select>
          </div>
        </template>
        <div class="col-12 px-2 mt-2 mb-2 row mx-0" style="border-bottom: 1px solid #ccc;">{{ t('filterAttributesHeader', 'filterAttributesHeader') }}</div>
        <template v-for="input in formAttributesWithData">
          <template v-for="data in input">
            <template v-if="(editRuleData[data.name]) || ( data.name == 'batch_type' ) || editRuleData[data.name] == '0' || editRuleData[data.name] === null">
              <template v-if="(data.type == 'text') && (data.title != 'ruleId') && (data.title != 'description')">
                <div class="row mx-0">
                  <template v-if="Array.isArray(data.exceptionRule)">
                    <div class="col-sm-12 col-md-6 col-lg-6 px-2">
                      <label :for="data.title + '-exception-rule'" class="d-block text-center">{{t('operation','operation')}}</label>
                      <select :id="data.title + '-exception-rule'" @change="clearExceptionRule(data.name, $event)" v-model="editRuleData[data.name]['exception_operator']" class="form-control custom-select text-capitalize">
                        <option selected :value="null">{{ t('noOperationOption', 'noOperationOption') }}</option>
                        <option v-for="exRule in data.exceptionRule" :value="exRule" :key="exRule">{{ t('operation_' + exRule, 'operation_' + exRule) }}</option>
                      </select>
                    </div>
                    <div class="col-sm-12 col-md-6 col-lg-6 px-2">
                      <label :for="data.title" class="d-block text-center">{{t(data.title, data.title)}}</label>
                      <input :disabled="!editRuleData[data.name]['exception_operator']" :id="data.title" v-model="editRuleData[data.name]['value']" class="form-control" :placeholder="t(data.title,data.title)" type="text">
                    </div>
                  </template>
                  <template v-else>
                    <div class="col-12 px-2">
                      <label :for="data.title" class="d-block text-center">{{t(data.title, data.title)}}</label>
                      <input :disabled="!editRuleData[data.name]['exception_operator']" :id="data.title" v-model="editRuleData[data.name]['value']" class="form-control" :placeholder="t(data.title,data.title)" type="text">
                    </div>
                  </template>
                </div>
              </template>
              <template v-if="(data.type == 'list')">
                <template v-if="data.name == 'batch_type'">
                  <div class="col-12 px-2">
                    <label :for="data.title" class="d-block text-center">{{ t(data.title, data.title) }}</label>
                    <select :id="data.title" @change="clearExceptionRule(data.name, $event)" v-model="editRuleData['batch_type']" class="form-control custom-select text-capitalize">
                      <template>
                        <option :value="null"> {{ t('batchAllOption', 'batchAllOption') }}</option>
                        <option v-for="batchType in batchTypes" :value="batchType.id" :key="batchType.id">{{ batchType.name }}</option>
                      </template>
                    </select>
                  </div>
                </template>
                <template v-else>
                  <div class="col-12 row align-items-baseline">
                    <p class="col-sm-12 col-md-6 col-lg-6">{{ t(data.label,data.label) }}: </p>
                    <select v-model="editRuleData[data.name]['value']" @change="clearExceptionRule(data.name, $event)"  class="form-control custom-select text-capitalize col-sm-12 col-md-6 col-lg-6">
                      <option v-if="data.name != 'enabled'" :value="null">{{t('selectAll','selectAll') }}</option>
                      <template v-if="data.name == 'customer_type'" >
                        <option v-for="customerType in data.values" :value="customerType.id" :key="customerType.value_code">{{ customerType.value_name }}</option>
                      </template>
                      <template v-if="data.name == 'invoice_type'">
                        <option v-for="invoiceType in data.values" :value="invoiceType.id" :key="invoiceType.value_code">{{ invoiceType.value_name }}</option>
                      </template>
                      <template v-if="data.name == 'document_type'">
                        <option v-for="documentType in documentTypes" :value="documentType.id" :key="documentType.id">{{ documentType.name }}</option>
                      </template>
                      <template v-if="(data.name == 'entity') || (data.title == 'country')"> 
                        <option v-for="entity in entities" :value="entity.id" :key="entity.id">{{ entity.combined_name }}</option>
                      </template>
                      <template v-if="data.name == 'entity_code'"> 
                        <option v-for="entityCode in data.values" :value="entityCode.id" :key="entityCode.value_code">{{ entityCode.value_name }}</option>
                      </template>
                      <template v-if="data.name == 'brand'">
                        <option v-for="brand in brands" :value="brand.id" :key="brand.id">{{ brand.brand }}</option>
                      </template>
                    </select>
                  </div>
                </template>
              </template>
              <template v-if="(data.type == 'multiple')">
                <div class="row mx-0 mt-2" v-if="data.name != 'enabled'">
                  <template v-if="Array.isArray(data.exceptionRule)">
                    <div class="col-sm-12 col-md-6 col-lg-6">
                      <label :for="data.title + '-exception-rule'" class="d-block text-center">{{ t('operation','operation') }}</label>
                      <select :id="data.title + '-exception-rule'" @change="clearExceptionRule(data.name, $event)" v-model="editRuleData[data.name]['exception_operator']" class="form-control custom-select text-capitalize">
                        <option selected :value="null">{{ t('noOperationOption', 'noOperationOption') }}</option>
                        <option v-for="exRule in data.exceptionRule" :value="exRule" :key="exRule">{{ t('operation_' + exRule, 'operation_' + exRule) }}</option>
                      </select>
                    </div>
                    <div class="col-sm-12 col-md-6 col-lg-6">
                      <label :for="data.title" class="d-block text-center">{{ t(data.title,data.title) }}</label>
                      <select :disabled="!editRuleData[data.name]['exception_operator']" :multiple="editRuleData[data.name]['exception_operator'] && (editRuleData[data.name]['exception_operator'] == 'in_list' || editRuleData[data.name]['exception_operator'] == 'not_in_list')" :id="data.title" v-model="editRuleData[data.name]['value']" class="form-control custom-select text-capitalize">
                        <option v-if="data.name != 'enabled'" :value="null" selected>{{t('selectNone','selectNone') }}</option>
                        <template v-if="data.name == 'customer_type'">
                          <option v-for="customerType in data.values" :value="customerType.id" :key="customerType.value_code">{{ customerType.value_name }}</option>
                        </template>
                        <template v-if="data.name == 'invoice_type'">
                          <option v-for="invoiceType in data.values" :value="invoiceType.id" :key="invoiceType.value_code">{{ invoiceType.value_name }}</option>
                        </template>
                        <template v-if="data.name == 'document_type'">
                          <option v-for="documentType in documentTypes" :value="documentType.id" :key="documentType.id">{{ documentType.name }}</option>
                        </template>
                        <template v-if="(data.name == 'entity') || (data.title == 'country')">
                          <option v-for="entity in entities" :value="entity.id" :key="entity.id">{{ entity.combined_name }}</option>
                        </template>
                        <template v-if="data.name == 'entity_code'">
                          <option v-for="entityCode in data.values" :value="entityCode.id" :key="entityCode.value_code">{{ entityCode.value_name }}</option>
                        </template>
                        <template v-if="data.name == 'brand'">
                          <option v-for="brand in brands" :value="brand.id" :key="brand.id">{{ brand.brand }}</option>
                        </template>
                      </select>
                    </div>
                  </template>
                  <template v-else>
                    <div class="col-12 px-0">
                      <label :for="data.title" class="d-block text-center">{{t(data.title,data.title)}}</label>
                      <select :id="data.title" v-model="editRuleData[data.name]['value']" :multiple="editRuleData[data.name]['exception_operator'] && (editRuleData[data.name]['exception_operator'] == 'in_list' || editRuleData[data.name]['exception_operator'] == 'not_in_list')" :select-size="4" class="form-control custom-select text-capitalize">
                        <option :value="null" selected>{{t('selectNone','selectNone') }}</option>
                        <template v-if="data.name == 'customer_type'">
                          <option v-for="customerType in data.values" :value="customerType.id" :key="customerType.value_code">{{ customerType.value_name }}</option>
                        </template>
                        <template v-if="data.name == 'invoice_type'">
                          <option v-for="invoiceType in data.values" :value="invoiceType.id" :key="invoiceType.value_code">{{ invoiceType.value_name }}</option>
                        </template>
                        <template v-if="data.name == 'document_type'">
                          <option v-for="documentType in documentTypes" :value="documentType.id" :key="documentType.id">{{ documentType.name }}</option>
                        </template>
                        <template v-if="(data.name == 'entity') || (data.title == 'country')">
                          <option v-for="entity in entities" :value="entity.id" :key="entity.id">{{ entity.combined_name }}</option>
                        </template>
                        <template v-if="data.name == 'entity_code'">
                          <option v-for="entityCode in data.values" :value="entityCode.id" :key="entityCode.value_code">{{ entityCode.value_name }}</option>
                        </template>
                        <template v-if="data.name == 'brand'">
                          <option v-for="brand in brands" :value="brand.id" :key="brand.id">{{ brand.brand }}</option>
                        </template>
                      </select>
                    </div>
                  </template>
                </div>
              </template>
              <template v-if="data.type == 'radio'">
                <template v-for="radioValue in data.values">
                  <div class="col-sm-12 col-md-6 col-lg-3">
                    <b-form-group class="mt-0" :label="t(radioValue.value_code, radioValue.value_code)">
                      <b-form-radio v-model="editRuleData[data.name]['value']" :name="radioValue.value_code" :value="radioValue.value_name">
                        {{ t(radioValue.value_name,radioValue.value_name) }}
                      </b-form-radio>
                    </b-form-group>
                  </div>
                </template>
              </template>
              <template v-if="data.type == 'check'">
                <div class="col-sm-12 col-md-6 col-lg-6 mt-2">
                  <b-form-checkbox
                    v-model="editRuleData[data.name]"
                    name="checkbox-1"
                    value="1"
                    :unchecked-value="null"
                  >
                    {{ t(data.title, data.title) }}
                  </b-form-checkbox>
                </div>
              </template>
            </template>
          </template>
        </template>
        <template v-if="ruleData.instructions && !isLoading && instructionsLoaded">
          <div class="col-12">
            <div class="col-12 px-0 text-left mt-2 mb-2" style="border-bottom: 1px solid #ccc;">{{ t('ruleAttributesLabel', 'ruleAttributesLabel') }}</div>
          </div>
          <div class="my-2 col-12 row">
            <template v-for="ruleAttribute in ruleData.instructions">
              <template v-if="ruleAttribute.rule_attribute_type == 'text'">
                <div class="col-sm-12 col-md-6 col-lg-6">
                  <label :for="'attribute_text_' + ruleAttribute.rule_attribute_id" class="d-block text-center">{{ t(ruleAttribute.rule_attribute_title, ruleAttribute.rule_attribute_title) }}</label>
                  <input :id="'attribute_text_' + ruleAttribute.rule_attribute_id" v-model="editRuleData.rule_attributes[editRuleData.rule][ruleAttribute.rule_attribute_name]" class="form-control" type="text">
                </div>
              </template>
              <template v-if="ruleAttribute.rule_attribute_type == 'textarea'">
                <div class="col-sm-12 col-md-6 col-lg-6">
                  <label :for="'attribute_textarea_' + ruleAttribute.rule_attribute_id" class="d-block text-center">{{t(ruleAttribute.rule_attribute_title, ruleAttribute.rule_attribute_title)}}</label>
                  <b-form-textarea
                    :id="'attribute_textarea_' + ruleAttribute.rule_attribute_id"
                    v-model="editRuleData.rule_attributes[editRuleData.rule][ruleAttribute.rule_attribute_name]"
                    rows="3"
                    max-rows="6"
                  ></b-form-textarea>
                </div>
              </template>
              <template v-if="ruleAttribute.rule_attribute_type == 'multiple' || ruleAttribute.rule_attribute_type == 'list'">
                <div class="col-sm-12 col-md-6 col-lg-6">
                  <label :for="'attribute_list_' + ruleAttribute.rule_attribute_id" class="d-block text-center">{{t(ruleAttribute.rule_attribute_title, ruleAttribute.rule_attribute_title)}}</label>
                  <select :id="'attribute_list_' + ruleAttribute.rule_attribute_id" v-model="editRuleData.rule_attributes[editRuleData.rule][ruleAttribute.rule_attribute_name]" class="form-control custom-select">
                    <option :value="null">{{t('noOptionSelected', 'noOptionSelected')}}</option>
                    <option v-for="option in ruleAttribute.rule_attribute_options" :key="option.rule_attribute_title" :value="option.rule_attribute_title">
                      {{ t(option.attribute_option_name, option.attribute_option_name) }}
                    </option>
                  </select>
                </div>
              </template>
              <template v-if="ruleAttribute.rule_attribute_type == 'radio'">
                <div class="col-sm-12 col-md-6 col-lg-6">
                  <label :for="'attribute_radio_' + ruleAttribute.rule_attribute_id" class="d-block text-center">{{t(ruleAttribute.rule_attribute_title, ruleAttribute.rule_attribute_title)}}</label>
                  <b-form-checkbox-group :id="'attribute_radio_' + ruleAttribute.rule_attribute_id">
                    <b-form-radio v-for="option in ruleAttribute.rule_attribute_options" :key="option.attribute_option_name" :name="ruleAttribute.rule_attribute_title" :value="option.rule_attribute_title" v-model="editRuleData.rule_attributes[editRuleData.rule][ruleAttribute.rule_attribute_name]" class="col-sm-12 col-md-6 col-lg-6">
                      {{ t(option.attribute_option_name, option.attribute_option_name) }}
                    </b-form-radio>
                  </b-form-checkbox-group>
                </div>
              </template>
              <template v-if="ruleAttribute.rule_attribute_type == 'check'">
                <div class="col-sm-12">
                  <template v-if="ruleAttribute.rule_attribute_options">
                    <label :for="'attribute_check_' + ruleAttribute.rule_attribute_id" class="d-block text-center">{{t(ruleAttribute.rule_attribute_title, ruleAttribute.rule_attribute_title)}}</label>
                    <b-form-checkbox-group :id="'attribute_check_' + ruleAttribute.rule_attribute_id" v-model="editRuleData.rule_attributes[editRuleData.rule][ruleAttribute.rule_attribute_name]" class="mt-1">
                      <b-form-checkbox v-for="option in ruleAttribute.rule_attribute_options" :key="option.rule_attribute_title" :value="option.value" :unchecked-value="null">
                        {{t(option.rule_attribute_title, option.rule_attribute_title)}}
                      </b-form-checkbox>
                    </b-form-checkbox-group>
                  </template>
                  <template v-else>
                    <b-form-checkbox-group v-model="editRuleData.rule_attributes[editRuleData.rule][ruleAttribute.rule_attribute_name]" class="mt-1">
                      <b-form-checkbox :value="editRuleData.rule_attributes[editRuleData.rule][ruleAttribute.value]" :unchecked-value="null">
                        {{t(ruleAttribute.rule_attribute_title, ruleAttribute.rule_attribute_title)}}
                      </b-form-checkbox>
                    </b-form-checkbox-group>
                  </template>
                </div>
              </template>
            </template>
          </div>
        </template>
        
        <!-- Checkbox disabled because we already have a status dropdown, PW -->
        <!--<div class="col-12 row mx-0">
          <div class="col-sm-12 col-md-6 col-lg-6">
            <b-form-checkbox
              v-model="editRuleData.enabled"
              value="enabled"
              unchecked-value="disabled"
            >
            {{t('ruleIsEnabled','ruleIsEnabled')}}
            </b-form-checkbox>
          </div>
        </div>-->
      </template>

      <template v-else-if="hasConflict && !isLoading && getResponseInfo.conflictingRule">
        <h5>{{t('conflictDetected','conflictDetected')}}</h5>
        <p v-if="getResponseInfo.conflictingRule">{{t('pleaseAmendRule','pleaseAmendRule')}} {{ getResponseInfo.conflictingRule.id }} {{t('beforeTryingToEditTheCurrentRule', 'beforeTryingToEditTheCurrentRule')}}</p>
        <table class="table table-striped">
          <thead class="brand-color">
            <tr>
              <th scope="col">{{t('type', 'type')}}</th>
              <template v-for="input in formAttributesWithData">
                <template v-for="data in input">
                  <th scope="col" >{{t(data.label, data.label)}}</th>
                </template>
              </template>
              <th scope="col">{{t('rule', 'rule')}}</th>
            </tr>
          </thead>
          <tr>
            <th scope="row">{{t('conflictingRule', 'conflictingRule')}}</th>
            <template v-for="input in formAttributesWithData">
              <template v-for="data in input">
                <template v-if="getResponseInfo.conflictingRule">
                  <th v-if="getResponseInfo.conflictingRule[data.name] && (getResponseInfo.conflictingRule[data.name] != 0)" class="text-center">
                    <template v-if="data.name == 'batch_type'">
                      <template v-if="getResponseInfo.conflictingRule['batch_type_name']">
                        {{ getResponseInfo.conflictingRule['batch_type_name'] }}
                      </template>
                      <template v-else>
                        {{ getResponseInfo.conflictingRule[data.name] }}
                      </template>
                    </template>
                    <template v-else>
                      {{getResponseInfo.conflictingRule[data.name]}}
                    </template>
                  </th>
                  <th v-else class="text-center"> - </th>
                </template>
              </template>
            </template>
            <th v-if="getResponseInfo.conflictingRule" scope="row">{{getResponseInfo.conflictingRule['rule_description'] }}</th>
          </tr>
          <tr>
            <th scope="row">{{t('editedRule', 'editedRule')}}</th>
            <template v-for="input in formAttributesWithData">
              <template v-for="data in input">
                <template v-if="getResponseInfo.ruleToBeAdded">
                  <th v-if="getResponseInfo.ruleToBeAdded[data.name] && (getResponseInfo.ruleToBeAdded[data.name] != 0)" class="text-center">
                    <template v-if="data.name == 'batch_type'">
                      <template v-if="getResponseInfo.ruleToBeAdded['batch_type_name']">
                        {{ getResponseInfo.ruleToBeAdded['batch_type_name'] }}
                      </template>
                      <template v-else>
                        {{ getResponseInfo.ruleToBeAdded[data.name] }}
                      </template>
                    </template>
                    <template v-else>
                      {{getResponseInfo.ruleToBeAdded[data.name]}}
                    </template>
                  </th>
                  <th v-else class="text-center"> - </th>
                </template>
              </template>
            </template>
            <th v-if="getResponseInfo.ruleToBeAdded" scope="row">{{getResponseInfo.ruleToBeAdded['rule_description'] }}</th>
          </tr>
        </table>
        <div class="col-12 row justify-content-end">
          <button class="btn btn-success" type="button" @click="cancelForm()">
            <fontAwesomeIcon :icon="['fa', 'check']" size="1x" class="mr-2"/>{{ t('keepExistingRuleButtonText', 'keepExistingRuleButtonText')}}
          </button>
          <button class="btn btn-danger ml-2" type="button" @click="discardAndUpdateRule()">
            <fontAwesomeIcon :icon="['fa', 'times']" size="1x" class="mr-2"/>{{ t('discardExistingAndUpdateRuleButtonText', 'discardExistingAndUpdateRuleButtonText')}}
          </button>
          <button class="btn btn-secondary ml-2" type="button" @click="ignoreConflictAndEdit()">
            <fontAwesomeIcon :icon="['fa', 'plus']" size="1x" class="mr-2"/>{{ t('ignoreRuleConflictButtonText', 'ignoreRuleConflictButtonText')}}
          </button>
        </div>
      </template>

      <div ref="message">
        <ResponseInfo class="mt-3" v-if="(getResponseInfo.responseName == 'editModal') && (getResponseInfo.status == 'error') && !hasConflict"></ResponseInfo>
        <div v-if="getResponseInfo.responseName == 'editModal'" class="col-12">
          <b-alert v-if="getResponseInfo.conflictId" variant="info" dismissible show fade @dismissed="clearResponse">
            <span>{{ t('conflictingRuleId', 'conflictingRuleId')}}</span>
            <span class="font-weight-bold">
              #{{getResponseInfo.conflictId}}
            </span>
          </b-alert>
        </div>
      </div>

    </template>
    <template slot="modal-footer" slot-scope="{ cancel }">
      <button aria-label="Cancel" data-dismiss="modal" class="btn btn-secondary" type="button" @click="cancel()">
        <fontAwesomeIcon :icon="['fa', 'ban']" class="text-light mr-2"/>{{ t('cancelAndCloseButtonText', 'cancelAndCloseButtonText')}}
      </button>
      <template v-if="modal.modalData && !hasConflict">
        <div v-if="buttonIsBusy">
          <div class="sk-folding-cube">
            <div class="sk-cube1 sk-cube"></div>
            <div class="sk-cube2 sk-cube"></div>
            <div class="sk-cube4 sk-cube"></div>
            <div class="sk-cube3 sk-cube"></div>
          </div>
        </div>
        <button v-if="!buttonIsBusy" aria-label="EditRule" data-dismiss="modal" class="btn btn-primary" type="button" @click="editRule()">
          <fontAwesomeIcon :icon="['fa', 'pen']" size="1x" class="mr-2"/>{{ t('editRuleButtonText', 'editRuleButtonText')}}
        </button>
      </template>
    </template>
  </b-modal>
</template>

<script>
import { mapGetters } from 'vuex'
import ResponseInfo from '@/components/ResponseInfo.vue'
import { clientShortName } from '@/helpers/clientShortName.js'

export default {
  name: 'edit_rule_modal',
  inject: [
    'modal',
    'resetModal',
    'refreshResults',
    'clearResponse',
    'hideModal'
  ],
  data () {
    return {
      isLoading: false,
      instructionsLoaded: false,
      buttonIsBusy: false,
      editRuleData: {
        rule_attributes: {},
        rule: 0,
        batch_type: null,
        document_value: {
          value: null,
          exception_rule: null
        }
      }
    }
  },
  computed:{
    ...mapGetters(['getResponseInfo']),
    hasConflict() {
      let response = this.getResponseInfo
      if(response.key == "conflictFound") {
        return true
      } else {
        return false
      }
    },
    formAttributesWithData() {
      return this.$store.getters['sendExceptionsStore/getSendExceptionRulesSearchFilters']
    },
    instructionFormAttributes() {
      return this.$store.getters['sendExceptionsStore/getSendExceptionInstructions']
    },
    formAttributes() {
      return this.$store.getters['sendExceptionsStore/getSendExceptionRulesAttributes']
    },
    documentTypes() {
      return this.$store.getters['sendExceptionsStore/getDocTypes']
    },
    batchTypes() {
      return this.$store.getters['sendExceptionsStore/getBatchTypes']
    },
    entities() {
      return this.$store.getters['sendExceptionsStore/getEntities']
    },
    brands() {
      return this.$store.getters['sendExceptionsStore/getBrands']
    },
    rules() {
      return this.$store.getters['sendExceptionsStore/getRules']
    },
    ruleData() {
      return this.$store.getters['sendExceptionsStore/getRuleData']
    },
    clientName() {
			let clientName = clientShortName()
			return clientName
		}
  },
  methods: {
    clearExceptionRule(name, event) {
      if(this.editRuleData[name] && this.editRuleData[name]['value']) {
        
        let operator = null
        if(event.target.value && event.taget.value != '') {
          operator = event.target.value
        }

        this.editRuleData[name] = {}
        this.editRuleData[name]['value'] = new Array()
        this.editRuleData[name]['exception_operator'] = operator
      }

      this.$forceUpdate()
    },
    setDefaults() {
      this.isLoading = true
      this.$store.dispatch('sendExceptionsStore/getSendExceptionRulesAttributes').then(
        () => {
          /* for (const index in this.formAttributes) {
            let value = this.modal.ruleData[this.formAttributes[index]]
            if((this.formAttributes[index] == 'customer_ref') || (this.formAttributes[index] == 'document_ref')) {
                if(value == 0) {
                    value = null
                }
            }
            this.editRuleData[this.formAttributes[index]] = value
          }

          for (const index in this.formAttributesWithData['multiple']) {
            if(this.formAttributesWithData['multiple'][index]['name'] != 'enabled' && this.formAttributesWithData['multiple'][index]['name'] != 'ruleId') {
              this.editRuleData[this.formAttributesWithData['multiple'][index]['name']] = []
            }
          } */

          let rule = undefined
          if(this.modal.ruleData.rule_number && (this.modal.ruleData.rule_number != undefined)) {
            rule = this.modal.ruleData.rule_number
          }
          this.editRuleData.rule = Number(rule)
          this.editRuleData.batch_type = null

          this.$store.dispatch('sendExceptionsStore/getRuleData', this.modal.ruleData.id).then(
            response => {

              // prepare all custom attributes with empty object for render
              for (const [key, value] of Object.entries(this.formAttributesWithData)) {
                if(value && value.length > 0) {
                  value.forEach(function(el) {
                    if(el.data_type && el.type != 'check' && (el.data_type == 'custom' || el.data_type == 'standard')) {
                      this.editRuleData[el.name] = {}
                      this.editRuleData[el.name]['value'] = null
                      this.editRuleData[el.name]['exception_operator'] = null
                    } else if (el.type == 'check' && el.data_type == 'custom') {
                      this.editRuleData[el.name] = new Array()
                    }
                  }, this)
                }
              }

              for (const [key, value] of Object.entries(response)) {
                if(key != 'instructions' && key != 'description' && key != 'enabled' && key != 'batch_type' && key != 'duplicate_document') {
                  let ruleVal = value
                  let ruleOperator = null

                  //console.log('### key: ' + key + ' type: ' + typeof value + ' call: ' + Object.prototype.toString.call(value))
                  //console.log(JSON. stringify(value))

                  if(typeof value == 'string' && value.includes("|")) {
                    ruleVal = value['value'].split("|")
                    ruleOperator = value['exception_operator']
                  } else if(typeof value == 'string' && value != 'enabled' && value != 'disabled') {
                    ruleVal = value['value']
                    ruleOperator = value['exception_operator']
                  } else if(value == null) {
                    ruleVal = new Array()
                  } else if(Object.prototype.toString.call(value) === '[object Array]') {
                    if(value) {
                      ruleVal = value
                    } else {
                      ruleVal = null
                    }
                  } else if(Object.prototype.toString.call(value) === '[object Object]') {
                    if(key != 'customer_ref' && key != 'document_ref' && key != 'batch_splitter') {
                      if(value['exception_operator'] == '=') {
                        ruleVal = value['value']
                      } else {
                        console.log(value)
                        if(value['value'] && value['value'].includes("|")) {
                          ruleVal = value['value'].split("|")
                        } else {
                          ruleVal = null
                        }
                      }
                    } else {
                      ruleVal = value['value']
                    }
                    
                    ruleOperator = value['exception_operator']
                  } else {
                    ruleVal = null
                  }

                  this.editRuleData[key] = {}
                  this.editRuleData[key]['value'] = ruleVal
                  this.editRuleData[key]['exception_operator'] = ruleOperator

                } else {
                  if(key == 'description') {
                    this.editRuleData[key] = value
                  } else if(key == 'enabled') {
                    this.editRuleData[key] = value
                  } else if (key == 'batch_type') {
                    this.editRuleData[key] = value
                  } else if (key == 'duplicate_document') {
                    this.editRuleData[key] = value
                  }
                }
              }

              if(response.instructions) {
                let respInstructions = response.instructions

                Object.keys(respInstructions).forEach(key => {
                  let inst = respInstructions[key]
                  this.editRuleData['rule_attributes'][rule][inst.rule_attribute_name] = inst.value
                });
              }

              this.instructionsLoaded = true
              this.isLoading = false
              this.$forceUpdate()
            }, this)
        }, this)

      
    },
    discardAndUpdateRule() {
      this.$store.dispatch('sendExceptionsStore/deleteSendException', this.getResponseInfo.conflictingRule.rule_id).then(() => {
        this.editRule()
      })
    },
    cancelForm() {
      this.cleanForm()
      this.$refs['edit-rule-modal-new'].hide()
    },
    cleanForm() {
      //resetting the form with the correct default values
      let attributes = this.editRuleData.rule_attributes
      for (const formDataIndex in this.editRuleData) {
        if(formDataIndex == 'rule_attributes'){
          for (const attributeIndex in attributes) {
            this.editRuleData.rule_attributes[attributeIndex] = {}
          }
        } else {
          if(formDataIndex == 'enabled') {
            this.editRuleData.enabled = 'enabled'
          } else {
            if(Array.isArray(this.editRuleData[formDataIndex])) {
              this.editRuleData[formDataIndex] = []
            } else {
              this.editRuleData[formDataIndex] = null
            }
          }
        }
      }
    },
    editRule() {
      this.$store.dispatch('sendExceptionsStore/editSendException', { id: this.modal.ruleData.id, ...this.editRuleData})
      .then(() => {
        let response = this.getResponseInfo
        if(response.status == 'success') {
          this.refreshResults()
          this.$refs['edit-rule-modal-new'].hide()
        }
        if(response.status == 'error'){
          this.$refs['message'].scrollIntoView()
        }
      })
    },
    ignoreConflictAndEdit() {
      this.$store.dispatch('sendExceptionsStore/editSendException', { id: this.modal.ruleData.id, type: 'ignoreConflict', ...this.editRuleData})
      .then(() => {
        let response = this.getResponseInfo
        if(response.status == 'success') {
          this.refreshResults()
          this.$refs['edit-rule-modal-new'].hide()
        }
        if(response.status == 'error'){
          this.$refs['message'].scrollIntoView()
        }
      })
    },
  },
  created() {
    //fetching the rules
    this.$store.dispatch('sendExceptionsStore/getRules').then(
      () => {
        for (const ruleIndex in this.rules) {
          //prepare the objects that will hold the rule attribute values
          //indexed by their rule's id
          this.editRuleData.rule_attributes[this.rules[ruleIndex].id] = {}
        }
      }
    )
    this.$store.dispatch('sendExceptionsStore/getSendExceptionRulesAttributes').then(
      () => {
        if(this.formAttributes.includes('batch_type')) {
          this.$store.dispatch('sendExceptionsStore/getBatchTypes')
        }

        if(this.formAttributes.includes('entity')) {
          this.$store.dispatch('sendExceptionsStore/getEntities')
        }

        if(this.formAttributes.includes('brand')) {
          this.$store.dispatch('sendExceptionsStore/getBrands')
        }

        if(this.formAttributes.includes('document_type')) {
          this.$store.dispatch('sendExceptionsStore/getDocumentTypes')
        }
      }
    )
    this.$store.dispatch('sendExceptionsStore/getSendExceptionRulesSearchFilters')
  },
  components:{
    ResponseInfo
  }
}
</script>
<style scoped>
  table >>> .brand-color {
    background-color: #047bf8 !important;
    color: white !important;
  }

  .modal-open #editRuleModalNew___BV_modal_outer_ >>> .modal-dialog{
    display: flex !important;
    justify-content: center !important;
  }
  .modal-open #editRuleModalNew___BV_modal_outer_ >>> .modal-content{
    min-width: 950px !important;
    max-width: auto !important;
    width: auto !important;
  }
  .modal-open #editRuleModalNew___BV_modal_outer_ >>> .modal-content .modal-body{
    max-height: 600px;
    overflow-y: scroll;
  }

  .form-extra-background{
    background-color: #eeeeee;
    padding: 5px;
    border-radius: 5px;
  }

  .rule-desc {
    color: #047bf8;
  }
</style>
